<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">Добавить квартиру</h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'block-details', params: { block_id: $route.params.block_id } }">← Назад к Квартирам</router-link>
    </div>

    <apartment-add-form :block="+$route.params.block_id" @after="handleAfter" />

  </div>
</template>

<script>
import apartmentAddForm from '@/components/forms/apartment/ApartmentAddForm'

export default {
  name: 'apartment-add',
  components: { apartmentAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'block-details', params: { block_id: this.$route.params.block_id } })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ApartmentAdd.vue?2f9f7570